import type { NativeEventType, NativeMessage } from './native.types'

export function createNativeMessage<T>(
  type: NativeEventType,
  payload?: T,
): NativeMessage<T> {
  return { type, payload }
}

export function isValidNativeMessage(obj: unknown): obj is NativeMessage {
  if (
    typeof obj !== 'object'
    || obj === null
  ) {
    return false
  }

  const maybeMsg = obj as { type?: unknown, payload?: unknown }

  if (
    typeof maybeMsg.type !== 'string'
    || typeof maybeMsg.payload !== 'object'
    || maybeMsg.payload === null
  ) {
    return false
  }

  const payload = maybeMsg.payload as { id?: unknown, data?: unknown }

  return (
    typeof payload.id === 'number'
    && typeof payload.data === 'string'
  )
}

function getAndroidBridge() {
  if (typeof window === 'undefined') {
    return undefined
  }
  return window.Android
}

export function isAndroidBridgeAvailable(): boolean {
  return !!getAndroidBridge()
}

export function isZebraDevice(): boolean {
  const bridge = getAndroidBridge()
  if (!bridge || typeof bridge.isZebraDevice !== 'function') {
    return false
  }
  try {
    return !!bridge.isZebraDevice()
  } catch {
    return false
  }
}

export function startScanning(successCallbackName: string, failureCallbackName: string): boolean {
  const bridge = getAndroidBridge()
  if (!bridge || typeof bridge.startScanning !== 'function') {
    return false
  }
  bridge.startScanning(successCallbackName, failureCallbackName)
  return true
}

export function stopScanning(successCallbackName: string, failureCallbackName: string): boolean {
  const bridge = getAndroidBridge()
  if (!bridge || typeof bridge.stopScanning !== 'function') {
    return false
  }
  bridge.stopScanning(successCallbackName, failureCallbackName)
  return true
}

export function getScanListForOrderIdAsJson(orderId: string): string {
  const bridge = getAndroidBridge()
  if (!bridge || typeof bridge.getScanListForOrderIdAsJson !== 'function') {
    return '[]'
  }
  return bridge.getScanListForOrderIdAsJson(orderId)
}
